// extracted by mini-css-extract-plugin
export default {"overlay":"Yy-z","bodyOpen":"Zy-z","content":"_y-z","header":"az-z","close":"bz-z","closeNoHeading":"cz-z"};